<template>
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <Title v-bind:text="title" v-bind:backArrow="true" backVue="dashboard-lab"/>
            <!-- <div class="info" @click="getPraticaData()">
                <img src="@/assets/info.svg" alt="info" />
            </div> -->
        </div>
        <!-- Bolle  -->
        <div class="bolle-container">
            <div class="d-flex justify-content-between align-items-center">
                <span> Bolle </span>
                <router-link :to="'/nuova-bolla/' + title + '~' + id_pratica" style="color: #707070;"> + aggiungi bolla</router-link>
            </div>
            <div class="bolle-list-container">
                <b-list-group>
                    <b-list-group-item v-if="!bolle.length" variant="secondary"><span>Non è ancora stata caricata alcuna bolla.</span></b-list-group-item>
                    <b-list-group-item button v-for="bolla in bolle" @click="openBollaModal(bolla)" :key="bolla.data_bolla" class="d-flex justify-content-between align-items-center list-item">
                        <span> {{bolla.nome}} </span>
                        <span><small>Data: </small> {{format_date(bolla.data_bolla)}}</span>
                    </b-list-group-item>                    
                </b-list-group>
            </div>
        </div>
        <!-- /Bolle -->
        <!-- Certificazione -->
        <div class="bolle-container">
            <div class="d-flex justify-content-between align-items-center">
                <span v-if="certificazione!=null"> Dichiarazione </span>
                <router-link v-if="certificazione==null" :to="'/nuova-certificazione/' + title + '~' + id_pratica" style="color: #707070; cursor:pointer;"> + aggiungi dichiarazione</router-link>
            </div>
            <div class="bolle-list-container">
                <b-list-group-item button v-if="certificazione!=null" @click="openCertModal(certificazione)" class="d-flex justify-content-between align-items-center list-item">
                    <span> Certificazione - {{certificazione.nome}} </span>
                    <span><small>Data: </small> {{format_date(certificazione.data_certificazione)}}</span>
                </b-list-group-item>                    
            </div>
        </div>
        <!-- /Certificazione -->
        <!-- Scheda Tecnica -->
        <div class="bolle-container">
            <div class="d-flex justify-content-between align-items-center" v-if="certificazione!=null">
                <span v-if="certificazione.scheda_tecnica!=null"> Scheda Tecnica </span>
                <input type="file" ref="file" style="display: none" @change="uploadSchedaTecnica">
                <span v-if="certificazione.scheda_tecnica==null" @click="getSchedaTecnica"  style="color: #707070; cursor:pointer;"> + aggiungi scheda tecnica</span>
            </div>
            <div class="bolle-list-container" v-if="certificazione!=null">
                <b-list-group-item button v-if="certificazione.scheda_tecnica!=null" @click="openCertModal(certificazione)" class="d-flex justify-content-between align-items-center list-item">
                    <span> Scheda Tecnica - {{certificazione.nome}} </span>
                    <span><small>Data: </small> {{format_date(certificazione.data_certificazione)}}</span>
                </b-list-group-item>                    
            </div>
        </div>
        <!-- / Scheda Tecnica -->
        <!-- Modal -->
        <!-- <b-modal id="editInfo" size="lg" title="Modifica pratica" button-size="sm" ok-variant="success" cancel-title="Annulla" @ok="editPratica()">
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Nome Pratica"
                label-for="nome"
            >
                <b-form-input id="nome" v-model="praticaData.nome"></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Numero Di Prescrizione"
                label-for="n_prescrizione"
            >
                <b-form-input id="n_prescrizione" type="number" v-model="praticaData.numero_prescrizione"></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Data della Prescrizione"
                label-for="date"
                required
            >
                <b-form-input id="date" type="date" v-model="praticaData.data_prescrizione"></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Nome Paziente"
                label-for="nome_paziente"
            >
                <b-form-input id="nome_paziente" v-model="praticaData.paziente_nome"></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Cognome Paziente"
                label-for="cognome_paziente"
            >
                <b-form-input id="cognome_paziente" v-model="praticaData.paziente_cognome"></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Codice Fiscale Paziente"
                label-for="cf_paziente"
            >
                <b-form-input v-model="praticaData.paziente_cf" id="cf_paziente" ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="4"
                label-cols-lg="3"
                label="Dottore"
                label-for="dottore"
            >
                <b-form-select
                    id="dottore"
                    v-model="dottore"
                    :options="praticaData.dottori"
                    required
                ></b-form-select>
            </b-form-group>
        </b-modal> -->
        <!-- / Modal -->
        <!-- Certificazione details -->
        <b-modal id="certDetails" size="xl" :hide-header="true" :hide-footer="true">
            <CertificazioneDetails :certificazione="certDetails" @closeModal="$bvModal.hide('certDetails');" />
        </b-modal>
        <!-- / Certificazione details -->
        <!-- Bolle details -->
        <b-modal id="bollaDetails" size="xl" :hide-header="true" :hide-footer="true">
            <BollaDetails :bolla="bollaDetails" @closeModal="$bvModal.hide('bollaDetails');" />
        </b-modal>
        <!-- / Bolle details -->
    </div>
</template>

<script>

import Title from "@/components/Title.vue";
import CertificazioneDetails from '@/components/Certificazione-Details.vue'
import BollaDetails from '@/components/Bolla-Details.vue'
import {mixins} from '@/mixins';

export default {
    name: "Pratica",
    data () {
        return {
            id_pratica: this.$route.params.id,
            // nome: this.$route.params.name,
            title: this.$route.params.name,
            data_bolla: null,
            data_cert: null,
            bolle: Array,
            certificazione: null,
            praticaData: Object,
            dottore: null,
            certDetails: Object,
            bollaDetails: Object
            
        }
    },
    components:{
        Title,
        CertificazioneDetails,
        BollaDetails
    },
    mixins: [mixins],
    created() {
        this.$axios
            .get(this.$apibase + "/api/bolle/get_bolle_by_pratica/", 
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        pratica: this.id_pratica
                    }
                }
            )
            .then(response => {
                this.bolle = response.data
            })
            .catch(e =>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
            this.$axios
            .get(this.$apibase + "/api/certificazioni/?pratica=" + this.id_pratica, {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                this.certificazione=response.data[0];
            })
            .catch(e =>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
                         
            })
    },
    methods: {
        // getPraticaData: function() {
        //     // Carico la pratica
        //     this.$axios
        //     .get(this.$apibase + "/api/pratica/" + this.id_pratica + "/", {
        //         headers: {
        //             Authorization:"JWT " + localStorage.getItem('access_token')
        //         }
        //     })
        //     .then(response => {
        //         delete response.data.uid;
        //         delete response.data.laboratorio;
        //         // Carico i dati del paziente
        //         this.$axios
        //         .get(response.data.paziente.replace(/^http?:\/\//,'https://'), 
        //             {
        //                 headers: {
        //                     Authorization:"JWT " + localStorage.getItem('access_token')
        //                 }
        //             })
        //         .then((paziente) => {
        //             delete response.data.paziente;
        //             response.data.paziente_nome = paziente.data.nome;
        //             response.data.paziente_cognome = paziente.data.cognome;
        //             response.data.paziente_cf = paziente.data.codice_fiscale;
        //             this.$axios
        //             .get(response.data.dottore.replace(/^http?:\/\//,'https://'), 
        //             {
        //                 headers: {
        //                     Authorization:"JWT " + localStorage.getItem('access_token')
        //                 }
        //             })
        //             .then((dottore) =>{
        //                 delete response.data.dottore;
        //                 this.dottore = dottore.data;
        //                 response.data["dottori"] = new Array;
        //                 response.data["dottori"].push(
        //                     {value: dottore.data, text: dottore.data.first_name + " " + dottore.data.last_name }
        //                 )
        //                 // Carico lista dei dottori
        //                 this.$axios
        //                 .get(this.$apibase + '/api/users/?groups=2', {
        //                     headers: {
        //                         Authorization:"JWT " + localStorage.getItem('access_token')
        //                     }
        //                 })
        //                 .then(dottori => {
        //                     let listaDottori = dottori.data.filter(doc => doc.uid != this.dottore.uid);
        //                     var instance;
        //                     for (instance of listaDottori){
        //                         response.data["dottori"].push(
        //                             {value: instance, text: instance.first_name + " " + instance.last_name }
        //                         )
        //                     }
        //                     this.praticaData = response.data;
        //                     this.$bvModal.show('editInfo')
        //                 })
        //             })
        //         })
        //     })
        // },
        // editPratica: function(){
        //     this.$axios
        //         .post(this.$apibase + '/api/pazienti/paziente/create_pratica_paziente_check/',
        //             {
        //                 nome: this.praticaData.paziente_nome,
        //                 cognome: this.praticaData.paziente_cognome,
        //                 codice_fiscale: this.praticaData.paziente_cf,
        //             },
        //             {
        //                 headers: {
        //                     Authorization:"JWT " + localStorage.getItem('access_token')
        //                 }
        //             },
        //         )
        //         .then(paziente => {
        //             this.$axios
        //             .patch(this.$apibase + "/api/pratica/" + this.id_pratica + "/", 
        //                 {
        //                     nome: this.praticaData.nome,
        //                     numero_prescrizione: this.praticaData.numero_prescrizione,
        //                     paziente: this.$apibase + '/api/pazienti/paziente/' + paziente.data.uid + '/',
        //                     dottore: this.$apibase + '/api/users/' + this.dottore.uid + '/',
        //                     data_prescrizione: this.praticaData.data_prescrizione,
        //                 },
        //                 {
        //                     headers: {
        //                         Authorization:"JWT " + localStorage.getItem('access_token')
        //                     }
        //                 }
        //             )
        //             .then(() => {
        //                 this.$router.push('/pratica/' + this.praticaData.nome + '~' + this.id_pratica);
        //             })
        //         })
        // },
        getSchedaTecnica: function(evt){
            evt.preventDefault();
            this.$refs.file.click();
        },
        uploadSchedaTecnica: function(){
            let new_st = new FormData();
            new_st.append('scheda_tecnica', this.$refs.file.files[0]);
            new_st.append('id_certificazione', this.certificazione.uid);
            this.$axios
                .post(this.$apibase + "/api/certificazioni/add_scheda_tecnica/",
                    new_st,
                    {
                        headers: {
                            Authorization:"JWT " + localStorage.getItem('access_token'),
                            'Content-Type': 'multipart/form-data;'
                        }
                    }
                )
                .then(() => {
                    this.$router.go()
                })
                .catch((e) => {
                    if (e.response.status == 403)
                        this.logout();
                    else
                        alert(e.response);
                })

        },
        openCertModal: function(cert){
            this.certDetails = cert;
            this.$bvModal.show('certDetails');
        },
        openBollaModal: function(bolla){
            this.bollaDetails = bolla;
            this.$bvModal.show('bollaDetails');
        }
    },
    // watch: {
    //     '$route.params.name': function(nome_pratica) {
    //         this.nome = nome_pratica;
    //     }
    // }
}
</script>

<style scoped>

    .bolle-container {
        padding-top: 40px;
    }

    .container{
        width: 70%;
        max-width: 800px;
    }

    .list-item{
        padding-left: 40px;
        padding-right: 40px;
        color: #707070;
    }
    
    .bolle-list-container{
        padding-top:30px;
    }

    .info{
        width: 20px;
        padding-top: 30px;
        cursor: pointer;
    }

</style>